module.exports = __webpack_public_path__ + "img/wallet-add-card.c5f19200.png";